import { render, staticRenderFns } from "./Kds2Sheet.vue?vue&type=template&id=b91b23a6"
import script from "./Kds2Sheet.vue?vue&type=script&lang=js"
export * from "./Kds2Sheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports